/**
 * This is the top level.
 *
 * Class TelemetryAgent
 *
 *Registering settings to redirect into corresponding files
 *Configuration settings of statistics, error and support widget in this class
 */
var assetsUrl="https://assets.citushealth.com";
var notifyEndpoint = '/hook/web/generic/v2/notify';
var TelemetryAgent = (function() {
    var instance;

    var createInstance = function(options) {
        this.apiKey = options.apiKey;
        this.releaseStage = options.releaseStage;
        this.userDetails = (typeof options.userData == 'function') ? options.userData() : options.userData;
        this.userDataConfig = options.userDataConfig;
        this.telemetryUrls = options.telemetryUrls;
        //abstract function
        var pageDataDecl = function() {
            console.log("Page data not enabled")
        };
        var eventDecl = function() {
            console.log("Check whether both custom statistics and pagedata is enabled")
        };
        var problemDecl = function() {
            console.log("Problems not enabled")
        };
        var feedbackDecl = function() {
            console.log("Feedback not enabled")
        };
        this.pageData = {
            statCount: pageDataDecl,
            statValue: pageDataDecl,
            Event: eventDecl,
            setNotifyLogin: pageDataDecl,
            setNotifyLogout: pageDataDecl,
            setUserData: pageDataDecl
        };
        this.problems = {
            Error: problemDecl,
            Warning: problemDecl,
            Event: problemDecl,
            Log: problemDecl,
            setCustomMetaData:problemDecl,
            setNotifyReleaseStages:problemDecl,
            setUserData:problemDecl
        };
        this.supportWidget = {
        	widgetApiPost: feedbackDecl,
            setUserData: feedbackDecl
        }

        var config = configSettings();
         if(config.supportWidget !== undefined){
            if(this.userDetails.enable_support_widget_branding  && this.userDetails.enable_support_widget_branding == 1 ) {
                var productNameShort =this.userDetails.app_name;
                config.supportWidget.supportTitle = productNameShort + ' Support';
                config.supportWidget.supportFormTitle = 'Submit Support Request in ' + productNameShort;
            }

        }
        if (config.problems !== undefined && config.pageData !== undefined && config.supportWidget !== undefined) {
            var Fingerprint = function() {
                var self = this;
                self.getScreenResolution = function() {
                    var resolution;
                    resolution = (screen.height > screen.width) ? [screen.height, screen.width] : [screen.width, screen.height];

                    return resolution;
                }
                self.hasLocalStorage = function() {
                    try {
                        return !!window.localStorage;
                    } catch (e) {
                        return true; // SecurityError when referencing it means it exists
                    }
                }
                var nativeForEach, nativeMap;
                nativeForEach = Array.prototype.forEach;
                nativeMap = Array.prototype.map;

                self.each = function(obj, iterator, context) {
                    if (obj === null) {
                        return;
                    }
                    if (nativeForEach && obj.forEach === nativeForEach) {
                        obj.forEach(iterator, context);
                    } else if (obj.length === +obj.length) {
                        for (var i = 0, l = obj.length; i < l; i++) {
                            if (iterator.call(context, obj[i], i, obj) === {}) return;
                        }
                    } else {
                        for (var key in obj) {
                            if (obj.hasOwnProperty(key)) {
                                if (iterator.call(context, obj[key], key, obj) === {}) return;
                            }
                        }
                    }
                }
                self.hasSessionStorage = function() {
                    try {
                        return !!window.sessionStorage;
                    } catch (e) {
                        return true; // SecurityError when referencing it means it exists
                    }
                }
                self.getPluginsString = function() {
                    return self.map(navigator.plugins, function(p) {
                        var mimeTypes = self.map(p, function(mt) {
                            return [mt.type, mt.suffixes].join('~');
                        }).join(',');
                        return [p.name, p.description, mimeTypes].join('::');
                    }, self).join(';');
                }
                self.map = function(obj, iterator, context) {
                    var results = [];
                    // Not using strict equality so that this acts as a
                    // shortcut to checking for `null` and `undefined`.
                    if (obj == null) return results;
                    if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
                    self.each(obj, function(value, index, list) {
                        results[results.length] = iterator.call(context, value, index, list);
                    });
                    return results;
                };
                self.isCanvasSupported = function() {
                    var elem = document.createElement('canvas');
                    return !!(elem.getContext && elem.getContext('2d'));
                }
                self.getCanvasFingerprint = function() {
                    var canvas = document.createElement('canvas');
                    var ctx = canvas.getContext('2d');
                    // https://www.browserleaks.com/canvas#how-does-it-work
                    var txt = 'https://wt.opsfol.io';
                    ctx.textBaseline = "top";
                    ctx.font = "14px 'Arial'";
                    ctx.textBaseline = "alphabetic";
                    ctx.fillStyle = "#f60";
                    ctx.fillRect(125, 1, 62, 20);
                    ctx.fillStyle = "#069";
                    ctx.fillText(txt, 2, 15);
                    ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
                    ctx.fillText(txt, 4, 17);
                    return canvas.toDataURL();
                }
                self.murmurhash3_32_gc = function(key, seed) {
                        var remainder, bytes, h1, h1b, c1, c2, k1, i;

                        remainder = key.length & 3; // key.length % 4
                        bytes = key.length - remainder;
                        h1 = seed;
                        c1 = 0xcc9e2d51;
                        c2 = 0x1b873593;
                        i = 0;

                        while (i < bytes) {
                            k1 =
                                ((key.charCodeAt(i) & 0xff)) |
                                ((key.charCodeAt(++i) & 0xff) << 8) |
                                ((key.charCodeAt(++i) & 0xff) << 16) |
                                ((key.charCodeAt(++i) & 0xff) << 24);
                            ++i;

                            k1 = ((((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16))) & 0xffffffff;
                            k1 = (k1 << 15) | (k1 >>> 17);
                            k1 = ((((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16))) & 0xffffffff;

                            h1 ^= k1;
                            h1 = (h1 << 13) | (h1 >>> 19);
                            h1b = ((((h1 & 0xffff) * 5) + ((((h1 >>> 16) * 5) & 0xffff) << 16))) & 0xffffffff;
                            h1 = (((h1b & 0xffff) + 0x6b64) + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16));
                        }

                        k1 = 0;

                        switch (remainder) {
                            case 3:
                                k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
                            case 2:
                                k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
                            case 1:
                                k1 ^= (key.charCodeAt(i) & 0xff);

                                k1 = (((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
                                k1 = (k1 << 15) | (k1 >>> 17);
                                k1 = (((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
                                h1 ^= k1;
                        }

                        h1 ^= key.length;

                        h1 ^= h1 >>> 16;
                        h1 = (((h1 & 0xffff) * 0x85ebca6b) + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
                        h1 ^= h1 >>> 13;
                        h1 = ((((h1 & 0xffff) * 0xc2b2ae35) + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16))) & 0xffffffff;
                        h1 ^= h1 >>> 16;

                        return h1 >>> 0;
                    }
                    // Fingerprinting
                self.getClientId = function() {
                    var keys = [];
                    keys.push(navigator.userAgent);
                    keys.push(navigator.language);
                    keys.push(screen.colorDepth);
                    var resolution = self.getScreenResolution();
                    if (typeof resolution !== 'undefined') { // headless browsers, such as phantomjs
                        keys.push(resolution.join('x'));
                    }
                    keys.push(new Date().getTimezoneOffset());
                    keys.push(self.hasSessionStorage());
                    keys.push(self.hasLocalStorage());
                    keys.push(!!window.indexedDB);
                    //body might not be defined at this point or removed programmatically
                    if (document.body) {
                        keys.push(typeof(document.body.addBehavior));
                    } else {
                        keys.push(typeof undefined);
                    }
                    keys.push(typeof(window.openDatabase));
                    keys.push(navigator.cpuClass);
                    keys.push(navigator.platform);
                    keys.push(navigator.doNotTrack);
                    keys.push(self.getPluginsString());
                    if (self.isCanvasSupported()) {
                        keys.push(self.getCanvasFingerprint());
                    }
                    return self.murmurhash3_32_gc(keys.join('###'), 31);
                }

            }
            var clientId = parseInt(localStorage.getItem('telemetryAgentClientId'));
            if (!clientId) {
                var FingerprintObject = new Fingerprint;
                clientId = FingerprintObject.getClientId();
                if (clientId) {
                    localStorage.setItem('telemetryAgentClientId', clientId);
                };
            }
            config.settings = {
                version: "4.1.36",
                lang: "js",
                devlApiUrl:   'https://admin-qa6.citushealth.com',
                portalApiUrl:   'https://portal.citushealth.com',
                devlAssetUrl:   'https://assets-qa6.citushealth.com',
                portalAssetUrl:   assetsUrl,
                apiBaseUrl: 'https://api.citushealth.com'+ notifyEndpoint, 
                apiTestBaseUrl: 'https://test-api.citushealth.com'+ notifyEndpoint,
                microServiceUrl: 'https://activity-tracking.netspective.com/api/accounts/7/activities.json',
                uploadServiceUrl: 'https://activity-attachment.netspective.com/api/accounts/7/attachment/file/upload.json',
                serviceId:2,
                pluginUrl: config.path.pluginUrl !== undefined ? config.path.pluginUrl : 'https://wt.opsfol.io/app/lib',
                contentType: "application/json",
                dataType: "json",
                async: true,
                processData: true,
                crossDomain: true,
                bulkData: false,
                crossDomain: true,
                notifyReleaseStageStatus: false, //initially false
                shouldNotify: true, // initially true
                localStorageSize: 4500, // MAX Local storage size. (5 MB per origin in Google Chrome, Mozilla Firefox, and Opera; 10 MB per storage area in Internet Explorer and Safari).
                agentSource: 2,
                exceptionType: 1,
                errorType: 2,
                logType: 3,
                warningType: 4,
                eventType: 5,
                loginRequestType: 1,
                logoutRequestType: 2,
                errorReportingLimit: 5,
                configSettingsActivityType: 'ConfigSettings',
                statisticType: 'Statistics',
                actvityType: 'Activity',
                problemsEnable: config.problems.enable !== undefined ? config.problems.enable : false,
                pageDataEnable: config.pageData.enable !== undefined ? config.pageData.enable : false,
                supportWidgetEnable: config.supportWidget.enable !== undefined ? config.supportWidget.enable : false,
                googleAnalyticsEnable: config.googleAnalytics.enable !== undefined ? config.googleAnalytics.enable : false,
                npsWidgetEnable: config.supportWidget.npsEnable !== undefined ? config.supportWidget.npsEnable : false,
                ajaxStatisticsEnable: config.pageData.allowAjaxStatistics !== undefined ? config.pageData.allowAjaxStatistics : false
            }

            // Use telemetry URLs from TypeScript if available
            if (this.telemetryUrls && this.telemetryUrls.portalApiUrl && this.telemetryUrls.apiBaseUrl && this.telemetryUrls.portalAssetUrl) {
                config.settings.portalApiUrl = this.telemetryUrls.portalApiUrl;
                config.settings.devlApiUrl = this.telemetryUrls.portalApiUrl;  // Use same URL for both portal and dev
                config.settings.apiBaseUrl = this.telemetryUrls.apiBaseUrl;
                config.settings.portalAssetUrl = this.telemetryUrls.portalAssetUrl;
            } else {
                // Fallback to original hardcoded logic if structure service is not available
                const pathArray = location.href.split( '/' );
                const protocol = pathArray[0];
                const host = pathArray[2];
                const url = protocol + '//' + host;
                if(url.endsWith('.citushealth.ca')){
                    config.settings.portalApiUrl = 'https://portal.citushealth.ca';
                    config.settings.apiBaseUrl = 'https://api.citushealth.ca'+ notifyEndpoint;
                    config.settings.portalAssetUrl = 'https://assets.citushealth.ca';
                } else if(url === 'https://my.kabafusion.com') {
                    config.settings.portalApiUrl = 'https://myadmin.kabafusion.com';
                    config.settings.apiBaseUrl = 'https://api.kabafusion.com'+ notifyEndpoint;
                    config.settings.portalAssetUrl = 'https://assets.kabafusion.com';
                } else {
                    config.settings.apiBaseUrl = url ? url.replace('app', 'api') : 'https://api.citushealth.com';
                    config.settings.apiBaseUrl += notifyEndpoint;
                }
            }
            config.settings.projectName ='CH Desktop App';
            var now = new Date();
            var now_utc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
            var month = ('0' + (parseInt(now_utc.getMonth()) + 1)).slice(-2);
            var date = ('0' + (now_utc.getDate())).slice(-2);
            var hour = ('0' + (now_utc.getHours())).slice(-2);
            var minute = ('0' + (now_utc.getMinutes())).slice(-2);
            var seconds = ('0' + (now_utc.getSeconds())).slice(-2);
            var createdAT = now_utc.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + seconds;
            var createdATUTC = now_utc.getTime();
            var createdTZ = now.toString().replace(/^.*GMT.*\(/, "").replace(/\)$/, "");
            var rand = Math.random().toString(36).slice(2).substring(1);
            var timestamp = (new Date().getTime() / 1000).toFixed(0);
            config.microServiceParams = {
                activityName: "",
                activityLevel: "",
                activityDescription: "",
                activityType: "",
                activityTag: "",
                hierarchyPath: "",
                scope: "",
                activitySeedName: "",
                source: "",
                destination: "",
                activityDataStructured: "",
                activityData: "",
                createdAt: createdAT,
                createdAtTz: createdTZ,
                createdAtGmt: createdATUTC,
                activityStatus: "",
                clientId: clientId,
                createdBy: "",
                activitySourceUniqueId: rand + timestamp,
                version: "",
                syncNow: "",
                relatedActivityId: "",
                parentActivityId: "",
                sessionUniqueId: "",
                organizationId: 8,
                projectId: "",
                environmentId: ""
            }

            config.register = {
                apiKey: this.apiKey,
                releaseStage: this.releaseStage,
                userDetails: this.userDetails,
                userDataConfig:this.userDataConfig
            }

            if ((typeof TelemetryAgentPageData != 'undefined')) {
                 //create an instance of page data
                   /*  pageData = TelemetryAgentPageData.getInstance(config);
                    if (config.settings.pageDataEnable) {
                        //send statistics data
                        pageData.statisticData(true, function() {
                            if (config.settings.ajaxStatisticsEnable) {
                                //send statistics call for each statistics call
                                pageData.telemetryAgentAjaxStatistics();
                            }
                        });
                    } */
                    /* commented as per request */
                    //send visitor tracking data
                        // if (document.cookie.indexOf(config.register.apiKey+'visited') == -1) {
                        //     pageData.vistiedOn(true);
                        // }

                    // if (document.cookie.indexOf("telemetryAgentConfigSettingsSend") == -1) {
                    //     var configSettingsValue = {
                    //             "problems": config.problems,
                    //             "pageData": config.pageData,
                    //             "supportWidget": config.supportWidget,

                    //         }
                    //         // send config settings data
                    //     pageData.sendConfigData(configSettingsValue, config.settings.configSettingsActivityType, function(status){
                    //     	if (status) {
                    //     		document.cookie = "telemetryAgentConfigSettingsSend=true; expires=0; path=/";
                    //     	};
                    //     });
                    // }


            }

            //To send automatic js errors
            if ((typeof TelemetryAgentProblems != 'undefined') && config.settings.problemsEnable) {
                //create an instance of problems
                problems = TelemetryAgentProblems.getInstance(config);
            }


            if ((typeof TelemetryAgentSupportWidget != 'undefined') && (config.settings.supportWidgetEnable || config.settings.npsWidgetEnable)) {
                //create an instance of Support Widget
                supportWidget = TelemetryAgentSupportWidget.getInstance(config);
                if (!config.supportWidget.widgetApi) {
                	supportWidget.init();
                }
            }
        }
        return {
            supportWidget: supportWidget,
            problems: problems,
            pageData: pageData
        };

    }
    return {
        getInstance: function(config) {
            if (!instance) {
                instance = createInstance(config);
            }
            //console.log('getInstance');
            return instance;
        },
        setUserData:function(userData){

            if (instance.supportWidget) {
                    instance.supportWidget.setUserData(userData);
                    instance.supportWidget.init();
            }

            if (instance.pageData) {
                  instance.pageData.setUserData(userData);
            }

            if (instance.problems) {
                   instance.problems.setUserData(userData);
            }




        }
    };
})();



// WEBPACK FOOTER //
// src/assets/telemetry_agent/dist/agent.js